module.exports = __webpack_public_path__ + "static/img/ninth_bg1.dd6a0ad9.jpg";